import $ from "jquery";
import "jquery-colorbox";
import {lockScroll, unlockScroll} from "./gnav";


// =============================================================
// モーダルウィンドウ
// =============================================================
/*
export function modalWindow() {

  if ($('#vimeo_video').length) {
    const player = new Player('vimeo_video', {
      url: 'https://vimeo.com/!***!/!***',
      // id: ***,
      width: 640,
    });

    $('.modal').each(function() {
      $(this).on('click', function() {
        const target = $(this).attr('data-target');
        const modal = document.getElementById(target);
        $(modal).fadeIn().css('display', 'flex');
        player.play().then(function() {
          console.log('再生');
        });
        return false;
      });
    });

    // 閉じるボタンを押した時の処理
    $('.modal_close').on('click', function() {
      $('.modal_area').fadeOut();
      // 閉じるボタンを押すとvimeo動画停止
      player.pause().then(function() {
        console.log('一時停止');
      });
      return false;
    });
  }

  if ($('#searchBtn').length) {
    $('#searchBtn').on('click', function() {
      const modal = $('#searchArea');
      const input = $('#s');
      $(modal).fadeIn().css('display', 'flex');
      $(input).focus();
      return false;
    });
    $('#searchAreaBg').on('click', function() {
      const modal = $('#searchArea');
      $(modal).fadeOut();
      return false;
    });
  }

}
*/


// =============================================================
// モーダルの実装 (jquery-colorbox)
// =============================================================

export function modalImages() {

  $('.gallery').each(function() {
    const galleryID = $(this).attr('id');
    $(this).find('.gallery-item .gallery-icon > a').colorbox({
      rel: galleryID,
      className: 'gallery-modal-default',
      transition: 'fade',
      speed: 500,
      fadeOut: 500,
      opacity: 0.5,
      maxWidth: "90%",
      maxHeight: "90%",
      current: "",
      previous: "<div class=\"btn_circle_wrap prev\"><div class=\"prev_link\" rel=\"prev\"><div class=\"btn_link_ico\"><svg class=\"ico_arrow\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 10l4-4 4 4\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div></div></div>",
      next: "<div class=\"btn_circle_wrap next\"><div class=\"next_link\" rel=\"next\"><div class=\"btn_link_ico\"><svg class=\"ico_arrow\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 10l4-4 4 4\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div></div></div>",
      close: "<div class=\"btn_circle_wrap btn_circle_close\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.758 17.243L12 12l5.243 5.243m0-10.486L12 12 6.758 6.757\" stroke=\"#384048\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></div>",
      xhrError: "コンテンツの読み込みに失敗しました。",
      imgError: "画像の読み込みに失敗しました。",
      onOpen: function() {
        lockScroll(false);
      },
      onClosed: function() {
        unlockScroll(false);
      },
    });
  });

  $('.js-gallery').each(function() {
    const galleryID = $(this).attr('data-id');
    $(this).find('.js-gallery-link').colorbox({
      rel: galleryID,
      className: 'js-gallery-modal',
      transition: 'fade',
      speed: 500,
      fadeOut: 500,
      opacity: 0.5,
      maxWidth: "90%",
      maxHeight: "90%",
      current: "",
      inline: true,
      previous: "",
      next: "",
      close: "<div class=\"modal_area_close\"><span class=\"modal_area_close_cross\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.758 17.243L12 12l5.243 5.243m0-10.486L12 12 6.758 6.757\" stroke=\"#384048\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></span><span class=\"modal_area_close_txt\"><svg class=\"ico_close\" width=\"34\" height=\"8\" viewBox=\"0 0 34 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3.74 7.2a4.2 4.2 0 01-1.49-.26 3.72 3.72 0 01-1.19-.75 3.514 3.514 0 01-.78-1.15A3.65 3.65 0 010 3.6c0-.52.093-1 .28-1.44.187-.44.45-.82.79-1.14.34-.327.737-.577 1.19-.75C2.713.09 3.21 0 3.75 0c.573 0 1.097.1 1.57.3.473.193.873.483 1.2.87l-.84.79a2.48 2.48 0 00-.85-.61 2.472 2.472 0 00-1.02-.21c-.367 0-.703.06-1.01.18-.3.12-.563.29-.79.51-.22.22-.393.48-.52.78-.12.3-.18.63-.18.99s.06.69.18.99c.127.3.3.56.52.78.227.22.49.39.79.51.307.12.643.18 1.01.18s.707-.067 1.02-.2c.313-.14.597-.35.85-.63l.84.8c-.327.38-.727.67-1.2.87-.473.2-1 .3-1.58.3zm4.026-.1v-7h1.3V6h3.66v1.1h-4.96zm9.139.1c-.547 0-1.05-.09-1.51-.27-.46-.18-.86-.43-1.2-.75a3.469 3.469 0 01-.79-1.14c-.187-.44-.28-.92-.28-1.44 0-.52.093-.997.28-1.43.187-.44.45-.82.79-1.14.34-.327.74-.58 1.2-.76.46-.18.96-.27 1.5-.27.547 0 1.047.09 1.5.27.46.18.86.433 1.2.76.34.32.603.7.79 1.14.187.433.28.91.28 1.43 0 .52-.093 1-.28 1.44-.187.44-.45.82-.79 1.14-.34.32-.74.57-1.2.75-.453.18-.95.27-1.49.27zm-.01-1.14c.353 0 .68-.06.98-.18.3-.12.56-.29.78-.51a2.52 2.52 0 00.7-1.77c0-.36-.063-.687-.19-.98-.12-.3-.29-.56-.51-.78a2.22 2.22 0 00-.78-.52c-.3-.12-.627-.18-.98-.18s-.68.06-.98.18c-.293.12-.553.293-.78.52-.22.22-.393.48-.52.78-.12.293-.18.62-.18.98 0 .353.06.68.18.98.127.3.3.563.52.79.22.22.48.39.78.51.3.12.627.18.98.18zm7.318 1.14c-.547 0-1.07-.077-1.57-.23-.5-.16-.897-.363-1.19-.61l.45-1.01c.28.22.627.403 1.04.55.413.147.837.22 1.27.22.367 0 .663-.04.89-.12.227-.08.393-.187.5-.32a.757.757 0 00.16-.47.628.628 0 00-.23-.51 1.594 1.594 0 00-.6-.31 8.2 8.2 0 00-.81-.22c-.293-.067-.59-.143-.89-.23a4.236 4.236 0 01-.81-.35 1.816 1.816 0 01-.59-.58c-.153-.24-.23-.547-.23-.92 0-.38.1-.727.3-1.04.207-.32.517-.573.93-.76.42-.193.95-.29 1.59-.29.42 0 .837.053 1.25.16.413.107.773.26 1.08.46l-.41 1.01a3.72 3.72 0 00-.97-.41 3.559 3.559 0 00-.96-.14c-.36 0-.653.043-.88.13-.22.087-.383.2-.49.34-.1.14-.15.3-.15.48a.67.67 0 00.22.52c.153.127.35.227.59.3.247.073.52.147.82.22.3.067.597.143.89.23.3.087.57.2.81.34.247.14.443.33.59.57.153.24.23.543.23.91 0 .373-.103.72-.31 1.04-.2.313-.51.567-.93.76-.42.187-.95.28-1.59.28zm5.319-4.19h3.48v1.07h-3.48V3.01zm.1 3h3.95V7.1h-5.25v-7h5.11v1.09h-3.81v4.82z\" fill=\"#384048\"></path></svg></span></div>",
      xhrError: "コンテンツの読み込みに失敗しました。",
      imgError: "画像の読み込みに失敗しました。",
      onOpen: function() {
        lockScroll(false);
      },
      onClosed: function() {
        unlockScroll(false);
      },
    });
    const $prev = $('.modal_area_btn .prev');
    const $next = $('.modal_area_btn .next');
    $prev.on('click', function() {
      $.colorbox.prev();
    });
    $next.on('click', function() {
      $.colorbox.next();
    });
  });

  $('.js-gallery-pickup-link').each(function() {
    $(this).on('click', function() {
      // 特定のグループIDを持つモーダルの最初のリンクを取得
      const targetGroupId = $(this).attr('data-btn-id'); // クリックするボタンのhrefを指定
      const $firstLinkInGroup = $(`.js-gallery-link[href="#${targetGroupId}"]`).first();

      // そのリンクをプログラム的にクリック
      $firstLinkInGroup.click();
      return false;
    });
  });
}
